import React, { useContext } from 'react';
import { Link, Navigate, useParams } from 'react-router';
import styled from 'styled-components';
import { Colors } from '@/common/colors/colors';
import {
	ADMIN_HOME_PATH,
	adminNavigationConfig,
} from '@/common/constants/navigationConfigs';
import { AuthContext } from '@/common/contexts/authContext';
import Icon from '@/common/components/Icon';
import { slugify } from '@/common/helpers/slugify';

const Wrapper = styled.div`
	padding: 30px 40px;
`;

const Header = styled.div`
	display: flex;
	align-items: baseline;
	gap: 12px;
	margin-bottom: 28px;
`;

const Title = styled.h3`
	color: ${Colors.darkBlue};
	font-weight: bold;
	margin: 0;
`;

const Count = styled.span`
	color: ${Colors.darkGray2};
	font-size: 14px;
`;

const Grid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
	gap: 16px;
`;

const Screen = styled(Link)`
	text-decoration: none;
	display: flex;
	align-items: center;
	gap: 14px;
	font-size: 16px;
	font-weight: bold;
	padding: 16px 18px;
	border-radius: 18px;
	background-color: white;
	border: 1px solid ${Colors.gray};
	color: ${Colors.darkBlue};
	transition: all 0.2s ease;

	&:hover {
		color: ${Colors.darkBlue};
		border-color: ${Colors.lightBlue};
		box-shadow: 0 8px 20px rgba(3, 80, 114, 0.15);
		transform: translateY(-2px);
	}
`;

const Text = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2px;
	min-width: 0;
`;

const Description = styled.span`
	font-size: 12.5px;
	font-weight: normal;
	color: ${Colors.newGray};
`;

const IconBubble = styled.div`
	width: 42px;
	height: 42px;
	border-radius: 14px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	background-color: ${Colors.lightlightBlue2};
`;

const NavigationSection = () => {
	const { sectionName } = useParams();
	const { checkAccess } = useContext(AuthContext);

	const section = adminNavigationConfig.find(
		(element) => element.list && slugify(element.name) === sectionName,
	);

	if (!section) {
		return <Navigate to={ADMIN_HOME_PATH} replace />;
	}

	const screens = section.list.filter((element) => checkAccess(element.access));

	return (
		<Wrapper>
			<Header>
				<Title>{section.name}</Title>
				<Count>{screens.length}</Count>
			</Header>
			<Grid>
				{screens.map((element) => (
					<Screen key={element.name} to={element.link}>
						<IconBubble>
							<Icon name={element.icon} size={20} />
						</IconBubble>
						<Text>
							{element.name}
							{element.description && (
								<Description>{element.description}</Description>
							)}
						</Text>
					</Screen>
				))}
			</Grid>
		</Wrapper>
	);
};

export default NavigationSection;
